import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Analisi SEO di una pagina con i testi del form (backend features/seoanalysis).
	// payload: { kind, id?, lang, keyword, name, slug, text, metatitle, metadescription, alts? }
	// Ritorna { data: { score, level, checks, suggerimenti, searchConsole } } oppure { error }.
	analyze: async (context, payload) => {
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}seoanalysis`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},

	// Analisi approfondita con l'IA: accoda un job, l'esito arriva sul socket MESSAGE_ITEM_REWRITE.
	// Ritorna { data: { jobId } } oppure { error }.
	deep: async (context, payload) => {
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}seoanalysis/deep`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
